/**
 * Created by Administrador on 16/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('settingSsr', {
                parent: 'app',
                url: '/settingSsr?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/ssr/settingSsr/classification/classifications.html',
                        controller: 'classificationSsrCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            'tabs': ['tabService', function (tabService) {
                                return tabService.getTabAdminClassificationsSsr('settingSsr'); // default selected
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['classificationSsr']);// to load json [us & es]
                            }],
                            classifications: ['classificationSsrService', '$stateParams', function (classificationSsrService, $stateParams) {
                                return classificationSsrService.getClassificationsSsr($stateParams.page, $stateParams.size);
                            }]
                        }
                    }
                }
            })
    }
})();
